export default __webpack_public_path__ + "static/sirio-2-819df4025bde84852baae5602f60271d.jpg";